module.exports = __webpack_public_path__ + "img/2. Prospects_for_a_Socially_Just_Transition_in_VietNam_frontcover.05c79b67.jpg";